import { Navigate } from "react-router-dom";
import useUserStore from "../stores/user";
import { useUrl } from "../composables/useUrl";

interface RoleRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

export default function RoleRoute({ children, allowedRoles }: RoleRouteProps) {
  const user = useUserStore((state) => state.user);
  const profile = useUserStore((state) => state.profile);
  const authResolved = useUserStore((state) => state.authResolved);
  const { getDashboardUrl } = useUrl();

  // Auth still resolving on cold load — hold, don't bounce to /login-portal
  if (!authResolved) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login-portal" replace />;
  }

  // Profile still loading — hold, don't flash-redirect
  if (!profile) {
    return null;
  }

  if (!allowedRoles.includes(profile.role)) {
    return <Navigate to={getDashboardUrl()} replace />;
  }

  return <>{children}</>;
}
